import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet'; // Import Helmet for managing head tags
import SignupForm from './utils/SignupForm';
import HealthSection from './utils/HealthSection';

const NDIS = () => {
    return (
        <div>
{/* While we test GTM for now, we have removed the Google Analytics code from here */}

            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Unveiling the Power of Manual Therapy Techniques at Ramp Physio and Fitnesse</h1>
                    <h2>This comprehensive article illuminates the transformative nature of manual therapy techniques in physiotherapy, chronic pain management, and sports injury rehabilitation, as practiced at Ramp Physio and Fitness.</h2>
                    <p>At Ramp Physio and Fitness, we understand that every body is unique and requires personalized care to achieve optimal health and performance. These hands-on methods have been instrumental in treating a wide range of conditions, from acute sports injuries to persistent chronic pain. In this article, we’ll delve into the essence of manual therapy, exploring its fundamental principles and the most effective techniques that we use to help our patients regain mobility, reduce pain, and improve their overall quality of life.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>The Essence of Manual Therapy</h1>
                        <p>Manual therapy is a cornerstone of physiotherapeutic intervention that involves a range of hands-on techniques aimed at alleviating pain, improving joint mobility, and enhancing function. It's not just about applying a technique; it's about understanding the intricate dance between the body's structures and how they can be harmonized for better movement and health. In the skilled hands of a Ramp Physio and Fitness therapist, these techniques become a powerful tool for healing.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Techniques That Transform</h1>
                    <p>Within the realm of manual therapy, there are several techniques that have proven to be particularly effective. Here are four key methods that we often incorporate into our treatment plans:</p>
                    <h1>1. Mobilization and Manipulation</h1>
                    <p>Mobilization involves slow, controlled movements applied to joints and soft tissues, while manipulation is a quicker, more precise force that aims to immediately enhance range of motion. Both are used to decrease pain and increase flexibility, often yielding profound results for patients struggling with stiffness and discomfort.</p>
                    <h1>2. Soft Tissue Techniques</h1>
                    <p>Soft tissue techniques, such as massage and myofascial release, target muscles, ligaments, and tendons. These methods not only soothe sore muscles but also promote blood circulation and healing, making them invaluable for both pre- and post-athletic activity as well as for those suffering from chronic conditions.</p>
                    <h1>3. Neuromuscular Techniques</h1>
                    <p>Neuromuscular techniques like trigger point therapy and nerve mobilization address the complex relationship between muscles, nerves, and the central nervous system. By focusing on these connections, we can alleviate pain patterns that have been resistant to other forms of treatment.</p>
                    <h1>4. Muscle Energy Techniques</h1>
                    <p>Muscle energy techniques (METs) involve active participation from the patient, who uses gentle muscle contractions to stretch and strengthen specific areas. This collaborative approach not only empowers the patient but also fosters a deeper connection between body awareness and healing.</p>
                </div>
            </div>
            </SkewedContainer>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Integrating Manual Therapy into Holistic Care</h1>
                    <p>At Ramp Physio and Fitness, we believe that manual therapy is most effective when integrated into a comprehensive treatment plan that includes exercise, education, and lifestyle modifications. Our goal is not just to treat the symptoms but to address the root cause of your discomfort, ensuring sustainable recovery and peak performance.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Navigating the Healing Journey</h1>
                    <p>As we apply these manual therapy techniques, we closely monitor your progress, adapting our approach to meet your evolving needs. Whether you're an athlete looking to return to your sport or someone seeking relief from chronic pain, our team at Ramp Physio and Fitness is here to support you every step of the way.</p>
                    <br></br>
                    <p>
                        In conclusion, manual therapy techniques are a vital part of the holistic care we provide at Ramp Physio and Fitness. Through our personalized approach and expert application of these methods, we help our patients achieve lasting health and wellness. If you're ready to experience the benefits of manual therapy, we invite you to join us on this transformative healing journey.
                    </p>
                </div>
            </div>
            </SkewedContainer>
            <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default NDIS;
